import firebase from "firebase";
// import "firebase/auth";

firebase.initializeApp({
  apiKey: "AIzaSyB4tIEtJMtbiKFPy5Dkk55C3pZNgHiY_T0",
  authDomain: "fireworks-test-5cb93.firebaseapp.com",
  projectId: "fireworks-test-5cb93",
  storageBucket: "fireworks-test-5cb93.appspot.com",
  messagingSenderId: "797436327373",
  appId: "1:797436327373:web:a40be576e3bf8475f34084",
});
// export const provider = new firebase.auth.TwitterAuthProvider();
export default firebase;
// Your web app's Firebase configuration
